import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
// eslint-disable-next-line import-x/extensions
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import { v5OrClassic } from '../nav';
import refragAvatar from '../../assets/logos/refrag-avatar.svg';

// Who is signed in, their links and admin impersonation: the avatar menu and the profile sidebar.
export default function useV5Account(props) {
  const { t } = useI18n();
  const auth = useAuth();
  const router = useRouter();

  const name = computed(() => props.user.username || props.user.steam_profile?.personaname || props.user.email || '');
  const avatar = computed(() => props.user.steam_profile?.avatarfull || refragAvatar);
  const impersonating = computed(() => auth.impersonating());
  const canImpersonate = computed(() => !impersonating.value && !!props.user.can_impersonate);

  const userLink = computed(() => props.user.username || props.user.uuid);
  const profileLink = computed(() => v5OrClassic(router, `/v5/user/${userLink.value}`, `/user/${userLink.value}`));
  const teamLink = computed(() => v5OrClassic(router, '/v5/team', '/team'));
  const settingsLink = computed(() => v5OrClassic(router, '/v5/settings', '/settings'));
  const friendCodesLink = computed(() => v5OrClassic(router, '/v5/friend_codes', '/friend_codes'));

  // As NavBar does it
  function impersonate() {
    // eslint-disable-next-line no-alert
    const id = window.prompt(t('v5.shell.impersonate_prompt'));
    if (id) auth.impersonate({ data: { id }, redirect: '/', makeRequest: true });
  }
  function stopImpersonating() {
    auth.unimpersonate({
      data: { id: props.user.id, client: auth.token().split('|')[2] },
      redirect: '/',
      makeRequest: true,
    });
  }

  return {
    name,
    avatar,
    impersonating,
    canImpersonate,
    profileLink,
    teamLink,
    settingsLink,
    friendCodesLink,
    impersonate,
    stopImpersonating,
  };
}
